export enum ConfirmJoinIVRResponseStatus {
  noResponse = 'noResponse',
  invalidSpeech = 'invalidSpeech',
  invalidDigits = 'invalidDigits',
  acceptedWithSpeech = 'acceptedWithSpeech',
  acceptedWithDigits = 'acceptedWithDigits',
}
